import { loadConnectAndInitialize } from "@stripe/connect-js";
import stripeConfig from "@/config/stripe";
import {
  CREATE_STRIPE_CONNECT_ACCOUNT,
  CREATE_STRIPE_CONNECT_ACCOUNT_SESSION,
  CREATE_STRIPE_CONNECT_PAYMENT_CONFIGURATION
} from "../../../store/booking-payment-providers/actions";
import defaultPaymentConfigurations from "../Interfaces/defaults.js";
import MixpanelEvents from "../../../constants/events";

export default {
  data() {
    return {
      isLoadingStripeConnectInstance: false,
      isLoadingStripeConnectOnboardingSession: false,

      connectAccountId: null,
      connectInstance: null,
      connectOnboardingSession: null,

      isConnectOnboardingSessionSuccessful: null
    };
  },
  methods: {
    async initStripeConnectInstance(ownerData) {
      this.isLoadingStripeConnectInstance = true;

      this.connectAccountId = await this.createStripeConnectAccount(ownerData);
      this.connectInstance = loadConnectAndInitialize({
        publishableKey: stripeConfig.keys.paymentAutomationPublic,
        fetchClientSecret: this.createStripeConnectAccountSession,
        fonts: [
          { cssSrc: "https://fonts.googleapis.com/css?family=Montserrat" }
        ],
        locale:
          this.$locale() === "it"
            ? "it-IT"
            : this.$locale() === "de"
            ? "de-DE"
            : this.$locale() === "es"
            ? "es-ES"
            : "en-US",
        appearance: {
          variables: {
            colorText: "#000000",
            buttonPrimaryColorBackground: "#0BA869",
            buttonPrimaryColorBorder: "#0BA869",
            buttonPrimaryColorText: "#FFFFFF",
            buttonSecondaryColorBackground: "#F5F5F5",
            buttonSecondaryColorBorder: "#F5F5F5",
            buttonSecondaryColorText: "#424242",
            colorSecondaryText: "#757575",
            actionSecondaryColorText: "#424242",
            actionSecondaryTextDecorationColor: "#424242",
            colorBorder: "#EDEDED",
            borderRadius: "8px",
            fontFamily: "Montserrat",
            headingXlFontWeight: "400",
            headingLgFontWeight: "400",
            headingMdFontWeight: "400",
            headingSmFontWeight: "400",
            headingXsFontWeight: "400"
          }
        }
      });

      this.isLoadingStripeConnectInstance = false;
    },
    async createStripeConnectAccount(ownerData) {
      const { accountId } = await this.$store.dispatch(
        CREATE_STRIPE_CONNECT_ACCOUNT,
        {
          name: ownerData.name,
          email: ownerData.email,
          phone: ownerData.phone,
          address: ownerData.address,
          city: ownerData.city,
          country: ownerData.country,
          vatId: ownerData.vat_code,
          taxId: ownerData.tax_code
        }
      );
      return accountId;
    },
    async createStripeConnectAccountSession() {
      const { accountSecret } = await this.$store.dispatch(
        CREATE_STRIPE_CONNECT_ACCOUNT_SESSION,
        { account: this.connectAccountId }
      );
      return accountSecret;
    },
    async createStripeConnectOnboardingSession(
      ownerType,
      ownerId,
      companyId,
      propertyId
    ) {
      this.isLoadingStripeConnectOnboardingSession = true;

      this.connectOnboardingSession =
        this.connectInstance.create("account-onboarding");
      this.connectOnboardingSession.setOnExit(async () => {
        const res = await this.$store.dispatch(
          CREATE_STRIPE_CONNECT_PAYMENT_CONFIGURATION,
          {
            ownerType: ownerType,
            ownerId: Number(ownerId),
            companyId: companyId,
            propertyId: propertyId,
            paymentConfig: {
              stripeAccountId: this.connectAccountId
            },
            accountConfig: {}
          }
        );

        if (res?.paymentConfigurations) {
          this.isConnectOnboardingSessionSuccessful = true;
          defaultPaymentConfigurations.paymentAutomationForm.data.configuration_id =
            res.paymentConfigurations.id;
          defaultPaymentConfigurations.paymentAutomationForm.status = 1;

          if (companyId) {
            this.$monitorService.track(
              MixpanelEvents.COMPANY_PAYMENT_AUTOMATION_CONFIGURED
            );
          } else if (propertyId) {
            this.$monitorService.track(
              MixpanelEvents.PROPERTY_PAYMENT_AUTOMATION_CONFIGURED
            );
          }
        } else {
          this.isConnectOnboardingSessionSuccessful = false;
        }

        await this.connectInstance.logout();
      });

      this.isLoadingStripeConnectOnboardingSession = false;
    }
  }
};
